import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { PegaChannelName, PegaNextAction, PegaNextActionEvent } from '@ap/pega';

import { BaseStarterAppDirective } from '../base-starter-app/base-starter-app.directive';
import { DistributionChannelType } from '../base-starter-app/base-starter-app.model';

import { ApPegaEventsRetail } from './starter-app-retail.model';

@Component({
    selector: 'pega-starter-app-retail',
    templateUrl: './starter-app-retail.component.html',
    standalone: false
})
export class StarterAppRetailComponent extends BaseStarterAppDirective implements OnChanges, ApPegaEventsRetail {
    @Input() public override apPegaChannel: PegaChannelName = PegaChannelName.RETAIL;

    protected distributionChannelType: DistributionChannelType = DistributionChannelType.RETAIL;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.pegaCaseTypeId) {
            this.ngOnInit();
        }
    }

    public onNextAction(event: PegaNextActionEvent): void {
        switch (event.action) {
            case PegaNextAction.Exit:
            case PegaNextAction.LogOff:
                if (this.apPegaCloseUrl) {
                    this.apWindowService.location_href(this.apPegaCloseUrl);
                    return;
                }

                if (event.payload) {
                    this.apWindowService.location_href(event.payload);
                    return;
                }

                this.apWindowService.location_href('/');
                break;
        }
    }
}
